import React from "react";
import { useNavigate } from "react-router-dom";
import { useBilling } from "../context/BillingContext";
import { Coins, X, Zap, Crown } from "lucide-react";

export default function PaywallModal() {
  const { paywall, setPaywall } = useBilling();
  const navigate = useNavigate();
  if (!paywall) return null;

  const close = () => setPaywall(null);
  const goBilling = () => { setPaywall(null); navigate("/billing"); };

  const niceAction = (paywall.action || "").replace(/_/g, " ");

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{ background: "rgba(15,27,45,0.65)", backdropFilter: "blur(4px)" }}
      data-testid="paywall-modal"
      onClick={close}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="rm-card-static max-w-md w-full p-6"
        style={{
          background: "white",
          borderColor: "#0F1B2D",
          boxShadow: "6px 6px 0 0 #FF6A00",
        }}
      >
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-2">
            <Zap size={20} className="rm-text-orange" />
            <div className="font-display uppercase text-xl" style={{ color: "#0F1B2D" }}>
              You're out of credits
            </div>
          </div>
          <button onClick={close} className="text-slate-400 hover:text-slate-700" data-testid="paywall-close">
            <X size={18} />
          </button>
        </div>

        <p className="text-sm mb-4" style={{ color: "#475569" }}>
          <span className="font-semibold capitalize" style={{ color: "#0F1B2D" }}>{niceAction}</span> needs <span className="rm-text-orange font-bold">{paywall.credits_needed} credits</span> to run.
          You currently have <span className="font-bold">{paywall.credits_balance}</span>.
        </p>

        <div className="space-y-2">
          <button
            onClick={goBilling}
            className="w-full rm-btn rm-btn-primary justify-center py-2.5"
            data-testid="paywall-buy-credits"
          >
            <Coins size={14} />
            Buy credits
          </button>
          <button
            onClick={goBilling}
            className="w-full rm-btn rm-btn-secondary justify-center py-2.5"
            data-testid="paywall-upgrade-pro"
          >
            <Crown size={14} />
            Or go Pro · unlimited
          </button>
        </div>

        <div className="mt-4 text-[11px] text-center" style={{ color: "#475569" }}>
          Free tier refreshes 10 credits on the 1st of each month.
        </div>
      </div>
    </div>
  );
}
